import { Routes, Route, HashRouter } from "react-router-dom";
import Quiz from "./Quiz";

function QuizHome() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/04-03-26" element={<Quiz for={"04-03-26"} />} />
        <Route path="/01-30-26" element={<Quiz for={"01-30-26"} />} />
        <Route path="/11-07-25" element={<Quiz for={"11-07-25"} />} />
        <Route path="/10-31-25" element={<Quiz for={"10-31-25"} />} />
        <Route path="/10-24-25" element={<Quiz for={"10-24-25"} />} />
        <Route path="/10-17-25" element={<Quiz for={"10-17-25"} />} />
        <Route path="/10-10-25" element={<Quiz for={"10-10-25"} />} />
        <Route path="/10-03-25" element={<Quiz for={"10-03-25"} />} />
        <Route path="/09-19-25" element={<Quiz for={"09-19-25"} />} />
        <Route path="/09-12-25" element={<Quiz for={"09-12-25"} />} />
        <Route path="/09-05-25" element={<Quiz for={"09-05-25"} />} />
        <Route path="/04-11-25" element={<Quiz for={"04-11-25"} />} />
        <Route path="/04-04-25" element={<Quiz for={"04-04-25"} />} />
        <Route path="/03-21-25" element={<Quiz for={"03-21-25"} />} />
        <Route path="/03-14-25" element={<Quiz for={"03-14-25"} />} />
        <Route path="/03-07-25" element={<Quiz for={"03-07-25"} />} />
        <Route path="/02-28-25" element={<Quiz for={"02-28-25"} />} />
        <Route path="/02-21-25" element={<Quiz for={"02-21-25"} />} />
        <Route path="/02-15-25" element={<Quiz for={"02-15-25"} />} />
        <Route path="/02-16-24" element={<Quiz for={"02-16-24"} />} />
        <Route path="/12-01-23" element={<Quiz for={"12-01-23"} />} />
        <Route path="/11-17-23" element={<Quiz for={"11-17-23"} />} />
        <Route path="/11-10-23" element={<Quiz for={"11-10-23"} />} />
        <Route path="/11-03-23" element={<Quiz for={"11-03-23"} />} />
        <Route path="/11-03-23" element={<Quiz for={"11-03-23"} />} />
        <Route path="/" element={<Quiz for={"11-03-23"} />} />
      </Routes>
    </HashRouter>
  );
}
export default QuizHome;
